define('modules/form_editor/views/editor_custom_gender',['require','exports','module','./editor_dropdown','./editor_custom_gender_item','ldsh!../templates/editor_custom_gender'],function(require, exports, module){
  "use strict";
  var EditorDropDown = require("./editor_dropdown");

  module.exports = EditorDropDown.extend({
    itemView: require("./editor_custom_gender_item"),
    template: require("ldsh!../templates/editor_custom_gender"),
    events: _.extend(EditorDropDown.prototype.events, {
      "change .js-other": "updateOther"
    }),
    onRender: function(){
      if(this.model.get("addOther")){
        this.$('select').append();
      }
    },
    updateOther: function() {
      var addOther = this.$('.js-other').is(':checked');
      this.model.setAddOther(addOther);
    }
  });
});

